(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf26us-black-friday-coupons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-sale-coupons')) {
    customElements.define('bf-sale-coupons', class extends HTMLElement {
      connectedCallback() {
        if (this.onCopy) return;
        this.onCopy = async event => {
          const card = event.target.closest('[data-code]');
          if (!card || !this.contains(card)) return;
          const code = card.dataset.code;
          if (!code) return;
          const label = card.querySelector('[data-copy-label]');
          label.dataset.originalLabel ||= label.textContent;
          const original = label.dataset.originalLabel;
          clearTimeout(card.copyTimer);
          let copied = false;
          try {
            if (navigator.clipboard?.writeText) {
              await navigator.clipboard.writeText(code);
              copied = true;
            }
          } catch {}
          if (!copied) {
            const field = document.createElement('textarea');
            field.value = code;
            field.setAttribute('readonly', '');
            field.style.cssText = 'position:fixed;left:-9999px;top:0;';
            this.append(field);
            field.select();
            try { copied = document.execCommand('copy'); } catch {}
            field.remove();
            card.focus({ preventScroll: true });
          }
          const status = this.querySelector('[role="status"]');
          if (copied) {
            label.textContent = this.dataset.copiedText;
            card.classList.add('is-copied');
            status.textContent = this.dataset.copiedText + ' ' + code;
            card.copyTimer = setTimeout(() => {
              label.textContent = original;
              card.classList.remove('is-copied');
            }, 2200);
          } else {
            status.textContent = this.dataset.copyFailed + ' ' + code;
          }
        };
        this.addEventListener('click', this.onCopy);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onCopy);
        this.onCopy = null;
        this.querySelectorAll('[data-code]').forEach(card => clearTimeout(card.copyTimer));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf26us-black-friday-free-chair"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bf-lucky-six')) {
  customElements.define('bf-lucky-six', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('.bf-free-chair__rules');
      trigger.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); }, options);
      dialog.querySelector('.bf-free-chair__close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      }, options);
    }
    disconnectedCallback() {
      this.querySelector('dialog')?.close();
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf26us-black-friday-timeline"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bf-sale-timeline')) {
  customElements.define('bf-sale-timeline', class extends HTMLElement {
    static dayInZone(now, timeZone) {
      if (!timeZone) throw new RangeError('Missing store time zone');
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
      return ['year', 'month', 'day'].map(type => parts.find(part => part.type === type).value).join('-');
    }
    static validSchedule(stages) {
      const validDate = value => {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
        const date = new Date(`${value}T00:00:00Z`);
        return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
      };
      return stages.length > 0 && stages.every((stage, index) => validDate(stage.start) && validDate(stage.end) && stage.start <= stage.end && (!index || stages[index - 1].end < stage.start));
    }
    static campaignForMoment(now, timeZone, stages) {
      try {
        if (!this.validSchedule(stages)) throw new RangeError('Invalid schedule');
        const day = this.dayInZone(now, timeZone);
        for (let index = 0; index < stages.length; index++) {
          if (day < stages[index].start) return { day, index, activeIndex: -1, state: 'upcoming' };
          if (day <= stages[index].end) return { day, index, activeIndex: index, state: 'active' };
        }
        return { day, index: stages.length - 1, activeIndex: -1, state: 'ended' };
      } catch {
        return { day: null, index: 0, activeIndex: -1, state: 'unavailable' };
      }
    }
    connectedCallback() {
      this.controller?.abort();
      clearInterval(this.scheduleTimer);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const details = [...this.querySelectorAll('details')];
      const status = this.querySelector('.bf-timeline__status');
      const stages = tabs.map(tab => ({ start: tab.dataset.startDate, end: tab.dataset.endDate }));
      this.manualPhase = false;
      this.scheduledIndex = undefined;
      const activate = (index, focus = false) => {
        this.dataset.viewedPhase = String(index + 1);
        tabs.forEach((tab, current) => {
          tab.setAttribute('aria-selected', String(current === index));
          tab.tabIndex = current === index ? 0 : -1;
          if (panels[current]) panels[current].hidden = current !== index;
        });
        if (focus) tabs[index]?.focus();
      };
      const selectMobile = index => {
        details.forEach((detail, current) => { detail.open = current === index; });
      };
      const selectManually = (index, focus = false) => {
        this.manualPhase = true;
        activate(index, focus);
        selectMobile(index);
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectManually(index), options);
        tab.addEventListener('keydown', event => {
          let target = index;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = tabs.length - 1;
          else return;
          event.preventDefault();
          selectManually(target, true);
        }, options);
      });
      details.forEach((detail, index) => {
        detail.querySelector('summary').addEventListener('click', () => {
          this.manualPhase = true;
          activate(index);
        }, options);
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          details.forEach(other => { if (other !== detail) other.open = false; });
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const index = details.findIndex(item => item.dataset.phaseBlock === event.detail.blockId);
        if (index >= 0) selectManually(index);
      }, options);
      const syncScheduledPhase = () => {
        if (!tabs.length || this.dataset.autoPhase !== 'true') return;
        const campaign = this.constructor.campaignForMoment(new Date(), this.dataset.timeZone, stages);
        this.dataset.campaignState = campaign.state;
        this.dataset.currentPhase = String(campaign.index + 1);
        this.dataset.activePhase = campaign.activeIndex < 0 ? '' : String(campaign.activeIndex + 1);
        this.dataset.offersActive = String(campaign.state === 'active');
        tabs.forEach((tab, index) => {
          const state = !campaign.day ? 'unavailable' : campaign.day < stages[index].start ? 'upcoming' : campaign.day > stages[index].end ? 'ended' : 'active';
          tab.dataset.phaseState = state;
          if (details[index]) details[index].dataset.phaseState = state;
        });
        if (status) {
          const text = campaign.state === 'upcoming' ? status.dataset.upcomingText : campaign.state === 'ended' ? status.dataset.endedText : '';
          if (status.textContent !== text) status.textContent = text;
          status.hidden = !text;
        }
        if (campaign.state !== 'unavailable' && campaign.index !== this.scheduledIndex && !this.manualPhase) {
          activate(campaign.index);
          selectMobile(campaign.index);
        }
        this.scheduledIndex = campaign.index;
      };
      syncScheduledPhase();
      if (this.dataset.autoPhase === 'true') {
        this.scheduleTimer = setInterval(syncScheduledPhase, 1000);
        document.addEventListener('visibilitychange', syncScheduledPhase, options);
        window.addEventListener('pageshow', syncScheduledPhase, options);
        window.addEventListener('focus', syncScheduledPhase, options);
      }
    }
    disconnectedCallback() {
      clearInterval(this.scheduleTimer);
      this.controller?.abort();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf26us-black-friday-winners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bf-winner-announcement')) {
  customElements.define('bf-winner-announcement', class extends HTMLElement {
    static indexForDay(day, dates) {
      const next = dates.findIndex(date => date >= day);
      return next < 0 ? dates.length - 1 : next;
    }
    connectedCallback() {
      this.controller?.abort();
      clearInterval(this.dateTimer);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const dates = tabs.map(tab => tab.dataset.date);
      this.manualDate = false;
      this.selectDate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index]?.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => { this.manualDate = true; this.selectDate(index); }, options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          this.manualDate = true;
          this.selectDate(next, true);
        }, options);
      });
      this.querySelectorAll('details').forEach(details => details.addEventListener('toggle', () => {
        if (details.open) details.parentElement.querySelectorAll('details').forEach(other => { if (other !== details) other.open = false; });
      }, options));
      this.addEventListener('shopify:block:select', event => {
        const index = tabs.findIndex(tab => tab.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.manualDate = true; this.selectDate(index); }
      }, options);
      let formatter;
      try { formatter = new Intl.DateTimeFormat('en-CA', { timeZone: this.dataset.timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }); } catch { return; }
      const sync = () => {
        if (this.manualDate || this.dataset.autoDate !== 'true' || !dates.length) return;
        if (!dates.every((date, i) => /^\d{4}-\d{2}-\d{2}$/.test(date) && (!i || date > dates[i - 1]))) return;
        const parts = formatter.formatToParts(new Date());
        const day = ['year', 'month', 'day'].map(type => parts.find(part => part.type === type).value).join('-');
        this.selectDate(this.constructor.indexForDay(day, dates));
      };
      sync();
      this.dateTimer = setInterval(sync, 1000);
      document.addEventListener('visibilitychange', sync, options);
    }
    disconnectedCallback() { this.controller?.abort(); clearInterval(this.dateTimer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf26us-header-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf26us-banner-countdown-control')) {
    customElements.define('bf26us-banner-countdown-control', class extends HTMLElement {
      static deadline(value) {
        const input = String(value || '').trim();
        if (/(?:z|[+-]\d{2}:?\d{2})$/i.test(input)) return Date.parse(input);
        const match = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?$/.exec(input);
        if (!match) return NaN;
        const parts = match.slice(1).map(part => Number(part || 0));
        const wallTime = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]);
        const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
        const localParts = moment => Object.fromEntries(formatter.formatToParts(new Date(moment)).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
        let instant = wallTime;
        for (let pass = 0; pass < 3; pass += 1) {
          const local = localParts(instant);
          const displayed = Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second);
          instant += wallTime - displayed;
        }
        const local = localParts(instant);
        return [local.year, local.month, local.day, local.hour, local.minute, local.second].every((part, index) => part === parts[index]) ? instant : NaN;
      }
      connectedCallback() {
        this.disconnectedCallback();
        this.endTime = this.constructor.deadline(this.dataset.end);
        this.mountHandler = () => this.mount();
        this.selectHandler = (event) => {
          if (event.target.contains(this) && this.output) {
            this.output.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        };
        document.addEventListener('DOMContentLoaded', this.mountHandler);
        document.addEventListener('shopify:section:load', this.mountHandler);
        document.addEventListener('shopify:section:reorder', this.mountHandler);
        document.addEventListener('shopify:section:select', this.selectHandler);
        this.mount();
        if (Number.isFinite(this.endTime) && this.endTime > Date.now()) {
          this.timer = setInterval(() => this.tick(), 1000);
        }
      }
      mount() {
        const slot = Array.from(document.querySelectorAll('[data-bf26us-banner-countdown-slot]'))
          .find((item) => !item.dataset.countdownOwner || item.dataset.countdownOwner === this.id);
        if (!slot) return;
        if (!this.output || this.output.parentElement !== slot) {
          this.removeOutput();
          this.output = this.querySelector('template').content.firstElementChild.cloneNode(true);
          slot.dataset.countdownOwner = this.id;
          this.bannerSlot = slot;
          slot.appendChild(this.output);
        }
        this.tick();
      }
      tick() {
        const remaining = this.endTime - Date.now();
        const active = Number.isFinite(remaining) && remaining > 0;
        if (this.output) {
          this.output.classList.toggle('is-ended', !active);
          if (active) {
            const parts = {
              days: Math.floor(remaining / 86400000),
              hours: Math.floor((remaining % 86400000) / 3600000),
              minutes: Math.floor((remaining % 3600000) / 60000),
              seconds: Math.floor((remaining % 60000) / 1000)
            };
            for (const [name, value] of Object.entries(parts)) {
              this.output.querySelector('[data-' + name + ']').textContent = String(value).padStart(2, '0');
            }
          }
        }
        if (!active) clearInterval(this.timer);
      }
      removeOutput() {
        if (this.output) this.output.remove();
        if (this.bannerSlot && this.bannerSlot.dataset.countdownOwner === this.id) delete this.bannerSlot.dataset.countdownOwner;
        this.output = undefined;
        this.bannerSlot = undefined;
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('DOMContentLoaded', this.mountHandler);
        document.removeEventListener('shopify:section:load', this.mountHandler);
        document.removeEventListener('shopify:section:reorder', this.mountHandler);
        document.removeEventListener('shopify:section:select', this.selectHandler);
        this.removeOutput();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf26us-mother-sale-final-clearance"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-clearance-size-sync')) {
    customElements.define('bf-clearance-size-sync', class extends HTMLElement {
      connectedCallback() {
        if (!document.body.classList.contains('template-suffix-black-friday-sale-2026')) return;
        this.controller?.abort();
        this.controller = new AbortController();
        this.syncHeight = () => {
          const cards = [...document.querySelectorAll('.mother-md-products__grid > .mother-md-card')];
          const height = Math.max(0, ...cards.map(card => card.getBoundingClientRect().height));
          if (height > 0 && this.isConnected) this.style.setProperty('--bf-reference-card-height', `${height}px`);
        };
        const observeProducts = () => {
          this.observer?.disconnect();
          this.observer = new ResizeObserver(this.syncHeight);
          document.querySelectorAll('.mother-md-products__grid > .mother-md-card').forEach(card => this.observer.observe(card));
          this.syncHeight();
        };
        observeProducts();
        document.fonts.ready.then(() => { if (this.isConnected) this.syncHeight(); });
        document.addEventListener('shopify:section:load', observeProducts, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clearance-product-list-v2"] && !Shopify.designMode) return;
  try {
    
  class ClearanceProductFilters {
    constructor(section) {
      this.section = section;
      this.grid = section.querySelector('[data-clearance-grid]');
      this.items = Array.from(section.querySelectorAll('[data-clearance-item]'));
      this.count = section.querySelector('[data-clearance-count]');
      this.empty = section.querySelector('[data-clearance-empty]');
      this.sidebar = section.querySelector('[data-clearance-sidebar]');
      this.stockButtons = Array.from(section.querySelectorAll('[data-clearance-stock]'));
      this.sortButtons = Array.from(section.querySelectorAll('[data-clearance-sort]'));
      this.sortButton = section.querySelector('[data-clearance-sort-button]');
      this.sortOptions = section.querySelector('#clearance-sort-dropdown-options');
      this.sortLabel = section.querySelector('[data-clearance-sort-label]');
      this.minInput = section.querySelector('[data-clearance-min-price]');
      this.maxInput = section.querySelector('[data-clearance-max-price]');
      this.minRange = section.querySelector('[data-clearance-min-range]');
      this.maxRange = section.querySelector('[data-clearance-max-range]');
      this.stockMode = 'show';
      this.sortMode = 'featured';
      this.priceBounds = this.getPriceBounds();
      this.bindEvents();
      this.initPriceInputs();
      this.apply();
    }

    bindEvents() {
      const toggle = this.section.querySelector('[data-clearance-toggle-filters]');
      if (toggle && this.sidebar) {
        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          const isHidden = this.sidebar.hasAttribute('hidden');
          this.sidebar.toggleAttribute('hidden', !isHidden);
          this.section.querySelector('filter-container')?.classList.toggle('filter-container--show-filters-desktop', isHidden);
        });
      }

      const priceToggle = this.section.querySelector('[data-clearance-price-toggle]');
      const pricePanel = this.section.querySelector('[data-clearance-price-panel]');
      if (priceToggle && pricePanel) {
        priceToggle.addEventListener('click', () => {
          pricePanel.toggleAttribute('hidden');
        });
      }

      if (this.sortButton && this.sortOptions) {
        this.sortButton.addEventListener('click', (event) => {
          event.preventDefault();
          const isOpen = this.sortButton.getAttribute('aria-expanded') === 'true';
          this.sortButton.setAttribute('aria-expanded', String(!isOpen));
          this.sortOptions.classList.toggle('link-dropdown__options--open', !isOpen);
        });
      }

      this.stockButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.stockMode = button.dataset.clearanceStock;
          this.stockButtons.forEach((item) => item.classList.toggle('clearance-filter-pill--active', item === button));
          this.apply();
        });
      });

      this.sortButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.sortMode = button.dataset.clearanceSort;
          this.sortButtons.forEach((item) => item.classList.toggle('link-dropdown__link--active', item === button));
          if (this.sortLabel) this.sortLabel.textContent = button.textContent.trim();
          if (this.sortButton) this.sortButton.setAttribute('aria-expanded', 'false');
          if (this.sortOptions) this.sortOptions.classList.remove('link-dropdown__options--open');
          this.apply();
        });
      });

      [this.minInput, this.maxInput, this.minRange, this.maxRange].forEach((input) => {
        if (!input) return;
        input.addEventListener('input', () => this.syncPriceInputs(input));
        input.addEventListener('change', () => this.apply());
      });
    }

    getPriceBounds() {
      const prices = this.items.map((item) => Number(item.dataset.price || 0));
      return {
        min: Math.floor(Math.min(...prices, 0)),
        max: Math.ceil(Math.max(...prices, 0))
      };
    }

    initPriceInputs() {
      [this.minInput, this.minRange].forEach((input) => {
        if (!input) return;
        input.min = this.priceBounds.min;
        input.max = this.priceBounds.max;
        input.value = this.priceBounds.min;
      });
      [this.maxInput, this.maxRange].forEach((input) => {
        if (!input) return;
        input.min = this.priceBounds.min;
        input.max = this.priceBounds.max;
        input.value = this.priceBounds.max;
      });
    }

    syncPriceInputs(source) {
      let min = Number(this.minInput?.value || this.priceBounds.min);
      let max = Number(this.maxInput?.value || this.priceBounds.max);

      if (source === this.minRange) min = Number(this.minRange.value);
      if (source === this.maxRange) max = Number(this.maxRange.value);
      if (min > max) {
        if (source === this.minInput || source === this.minRange) max = min;
        else min = max;
      }

      if (this.minInput) this.minInput.value = min;
      if (this.maxInput) this.maxInput.value = max;
      if (this.minRange) this.minRange.value = min;
      if (this.maxRange) this.maxRange.value = max;
      this.apply();
    }

    apply() {
      const min = Number(this.minInput?.value || this.priceBounds.min);
      const max = Number(this.maxInput?.value || this.priceBounds.max);
      let visibleCount = 0;

      this.items.forEach((item) => {
        const price = Number(item.dataset.price || 0);
        const available = item.dataset.available === 'true';
        const visible = price >= min && price <= max && (this.stockMode === 'show' || available);
        item.toggleAttribute('hidden', !visible);
        if (visible) visibleCount += 1;
      });

      this.sortItems();
      if (this.count) this.count.textContent = visibleCount;
      if (this.empty) this.empty.hidden = visibleCount > 0;
    }

    sortItems() {
      const sorted = [...this.items].sort((a, b) => {
        if (this.sortMode === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
        if (this.sortMode === 'title-descending') return b.dataset.title.localeCompare(a.dataset.title);
        if (this.sortMode === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
        if (this.sortMode === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
        if (this.sortMode === 'created-ascending') return Number(a.dataset.created) - Number(b.dataset.created);
        if (this.sortMode === 'created-descending') return Number(b.dataset.created) - Number(a.dataset.created);
        return Number(a.dataset.featuredIndex) - Number(b.dataset.featuredIndex);
      });
      sorted.forEach((item) => this.grid.appendChild(item));
    }
  }

  document.querySelectorAll('[data-clearance-section]').forEach((section) => new ClearanceProductFilters(section));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colletion-image-with-text"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener("DOMContentLoaded", function() {
      const leftListItems = document.querySelectorAll(".leftlist li");
      const rightPartBlocks = document.querySelectorAll(".rightPart");

      leftListItems[0].classList.add("itemactive");
      rightPartBlocks[0].classList.add("active");

      leftListItems.forEach(function(leftListItem, index) {
        leftListItem.addEventListener("click", function() {
   
          leftListItems.forEach(function(item) {
            item.classList.remove("itemactive");
          });
          rightPartBlocks.forEach(function(rightPartBlock) {
            rightPartBlock.classList.remove("active");
          });

          leftListItem.classList.add("itemactive");
          rightPartBlocks[index].classList.add("active");
        });
      });
    });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__homeCountdownBarInitialized) {
      return;
    }

    window.__homeCountdownBarInitialized = true;

    const padNumber = (value) => String(value).padStart(2, '0');

    const updateCountdown = (countdown) => {
      const endValue = countdown.getAttribute('data-end');
      if (!endValue) {
        return;
      }

      const endTime = new Date(endValue).getTime();
      if (Number.isNaN(endTime)) {
        return;
      }

      const remaining = Math.max(0, endTime - Date.now());
      const parts = {
        days: padNumber(Math.floor(remaining / 86400000)),
        hours: padNumber(Math.floor((remaining % 86400000) / 3600000)),
        minutes: padNumber(Math.floor((remaining % 3600000) / 60000)),
        seconds: padNumber(Math.floor((remaining % 60000) / 1000)),
      };

      Object.keys(parts).forEach((key) => {
        const field = countdown.querySelector(`[data-${key}]`);
        if (field) {
          field.textContent = parts[key];
        }
      });

      if (remaining === 0) {
        const root = countdown.closest('.home-countdown-bar');
        if (root) {
          root.classList.add('is-ended');
        }
      }
    };

    const syncCountdowns = () => {
      document.querySelectorAll('[data-home-countdown]').forEach(updateCountdown);
    };

    const initCountdowns = () => {
      if (!document.querySelector('[data-home-countdown]')) {
        return;
      }

      syncCountdowns();

      if (!window.__homeCountdownBarTimer) {
        window.__homeCountdownBarTimer = window.setInterval(syncCountdowns, 1000);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCountdowns, { once: true });
    } else {
      initCountdowns();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memorial-global-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-memorial-global-countdown]');
    if (!roots.length) {
      return;
    }

    const pad = (value) => String(value).padStart(2, '0');

    const deadline = (value) => {
        const input = String(value || '').trim();
        if (/(?:z|[+-]\d{2}:?\d{2})$/i.test(input)) return Date.parse(input);
        const match = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?$/.exec(input);
        if (!match) return NaN;
        const parts = match.slice(1).map(part => Number(part || 0));
        const wallTime = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]);
        const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
        const localParts = moment => Object.fromEntries(formatter.formatToParts(new Date(moment)).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
        let instant = wallTime;
        for (let pass = 0; pass < 3; pass += 1) {
          const local = localParts(instant);
          const displayed = Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second);
          instant += wallTime - displayed;
        }
        const local = localParts(instant);
        return [local.year, local.month, local.day, local.hour, local.minute, local.second].every((part, index) => part === parts[index]) ? instant : NaN;
      };

    const updateRoot = (root) => {
      const endValue = root.getAttribute('data-end');
      if (!endValue) {
        return false;
      }

      const target = deadline(endValue);
      if (Number.isNaN(target)) {
        return false;
      }

      const remaining = Math.max(0, target - Date.now());
      const values = {
        days: pad(Math.floor(remaining / 86400000)),
        hours: pad(Math.floor((remaining % 86400000) / 3600000)),
        minutes: pad(Math.floor((remaining % 3600000) / 60000)),
        seconds: pad(Math.floor((remaining % 60000) / 1000)),
      };

      Object.entries(values).forEach(([key, value]) => {
        root.querySelectorAll(`[data-${key}]`).forEach((node) => {
          node.textContent = value;
        });
      });

      if (remaining === 0) {
        root.style.display = 'none';
        return false;
      }

      return true;
    };

    let hasActiveCountdown = false;

    const sync = () => {
      hasActiveCountdown = false;
      roots.forEach((root) => {
        if (updateRoot(root)) {
          hasActiveCountdown = true;
        }
      });

      if (!hasActiveCountdown && window.__memorialGlobalCountdownTimer) {
        window.clearInterval(window.__memorialGlobalCountdownTimer);
        window.__memorialGlobalCountdownTimer = null;
      }
    };

    sync();

    if (!window.__memorialGlobalCountdownTimer && hasActiveCountdown) {
      window.__memorialGlobalCountdownTimer = window.setInterval(sync, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["musso-installation-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('musso-installation-player')) {
    customElements.define('musso-installation-player', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button || this.ready) return;
        this.ready = true;
        button.addEventListener('click', () => {
          const player = this.querySelector('.musso-installation__player');
          player.append(this.querySelector('template').content.cloneNode(true));
          player.hidden = false;
          button.hidden = true;
          const media = player.querySelector('iframe,video');
          media.focus();
          if (media.tagName === 'VIDEO') media.play().catch(() => {});
        }, { once:true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
